import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CheckmarkSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='8' cy='8' r='8' fill='#283E39' />
    <path
      d='M4 9.03255L6.58462 11.6992L12.4 5.69922'
      stroke='white'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const CheckmarkIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CheckmarkSvg} {...props} />
);
